export default __webpack_public_path__ + "static/media/ic-info-error.18ec1c39.svg";